/** 64-char hex invite token from the admin promo packages screen. */
export function normalizePromoInviteToken(
  raw: string | null | undefined,
): string | null {
  const s = raw?.trim()
  if (!s || !/^[a-f0-9]{64}$/i.test(s)) {
    return null
  }

  return s.toLowerCase()
}
